import { useTranslation } from 'modules/common/hooks/useTranslation'
import { useFormModal } from 'modules/common/modals/useFormModal/useFormModal'
import { SponsorshipVoucherFormModalContent } from '../components/SponsorshipVoucherFormModalContent/SponsorshipVoucherFormModalContent'
import { useValidateSponsorshipVoucherCodeFlow } from '../flows/useValidateSponsorshipVoucherCodeFlow'
import { useSponsorshipVoucherForm } from '../hooks/useSponsorshipVoucherForm'

export const useSponsorshipVoucherFormModal = () => {
  const { t, i18n } = useTranslation('auth-components')

  const form = useSponsorshipVoucherForm()
  const { watch } = form
  const voucherCode = watch('voucherCode')

  const { validateSponsorshipVoucherCode } =
    useValidateSponsorshipVoucherCodeFlow({
      voucherCode,
      queryOptions: {
        onError: () => {
          form.setError('voucherCode', {
            message: t('sponsorshipVoucherFormModal.voucherCode.notFound'),
          })
        },
      },
    })

  return useFormModal({
    width: 'base',
    headerTitle: t('sponsorshipVoucherFormModal.headerTitle'),
    content: <SponsorshipVoucherFormModalContent form={form} />,
    i18n,
    submitButtonText: t('sponsorshipVoucherFormModal.submitButton'),
    onSubmit: async () => {
      await validateSponsorshipVoucherCode()
      form.reset()
    },
    onCancel: form.reset,
    form,
  })
}
